import { render, staticRenderFns } from "./Proforma.vue?vue&type=template&id=325ea34e&scoped=true"
import script from "./Proforma.vue?vue&type=script&setup=true&lang=ts"
export * from "./Proforma.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Proforma.vue?vue&type=style&index=0&id=325ea34e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325ea34e",
  null
  
)

export default component.exports